import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderInputs, businessNameInput, commonPersonInputs } from "./utils";
import { useSubmit } from "module/common/components/forms";
import { putCriminal } from "module/main/store/appEndpoints/api";
var Criminal = function (_a) {
    var formSubmitCallBack = _a.formSubmitCallBack, formRef = _a.formRef;
    var handleSubmit = useSubmit(function (request) {
        var curatedPayload = {
            criminal_lookups: [
                {
                    first_name: request.first_name || null,
                    middle_name: request.middle_name || null,
                    last_name: request.last_name || null,
                    business_name: request.business_name || null,
                    age: request.age || null,
                    phone_number: request.phone_number || null,
                },
            ],
        };
        formSubmitCallBack(putCriminal, curatedPayload);
    });
    var restInputs = [
        businessNameInput,
        { id: "age", name: "age", placeholder: "Enter Age", label: "Age", type: "number" },
        {
            id: "phone_number",
            name: "phone_number",
            placeholder: "Enter Phone Number",
            label: "Phone Number",
            type: "tel",
        },
    ];
    return (_jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col", id: "endpoints-form", ref: formRef, children: [_jsx("h5", { className: "font-bold mb-2", children: "Criminal lookup:" }), _jsx("div", { className: "form-row", children: renderInputs(commonPersonInputs) }), _jsx("div", { className: "form-row", children: renderInputs(restInputs) })] }));
};
export default Criminal;
